module.exports = __webpack_public_path__ + "img/symbol_8.40100971.png";